// GTM 팝업 타게팅 스크립트가 읽는 유저 메타. 단일 소스 = getMe(/users/meta).
// 가입/프로필 플로우 전용 임시 키(userProfile)와 분리된 권위 키.
export const USER_META_STORAGE_KEY = "sol-user-meta";
export const clearUserMetaStorage = ()=>{
    if ("object" === "undefined") return;
    try {
        window.localStorage.removeItem(USER_META_STORAGE_KEY);
    } catch (e) {
        ;
    }
};
// getMe 결과로 매 진입 시 동기화. 로그인 유저면 최신값 기록, 아니면 잔존값 제거.
// → "sol-user-meta 존재 ⟺ 직전 로드 기준 로그인 상태" 불변식 유지(self-healing).
export const syncUserMetaToStorage = (user)=>{
    if ("object" === "undefined") return;
    // 비로그인/빈 유저: 이전 유저 값이 남지 않도록 제거.
    if (!(user === null || user === void 0 ? void 0 : user.uid)) {
        clearUserMetaStorage();
        return;
    }
    var _user_job, _user_mainSubject, _user_createdAt;
    const payload = {
        userType: (_user_job = user.job) !== null && _user_job !== void 0 ? _user_job : null,
        subject: (_user_mainSubject = user.mainSubject) !== null && _user_mainSubject !== void 0 ? _user_mainSubject : null,
        signupDate: (_user_createdAt = user.createdAt) !== null && _user_createdAt !== void 0 ? _user_createdAt : null
    };
    try {
        window.localStorage.setItem(USER_META_STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
        ;
    }
};
